<template>
  <div class="onboarding-complete-page">
    <h4 class="t-c font-normal">You're almost ready!</h4>

    <div class="content-area m-t-3 m-b-3">
      <!-- <h5 class="font-normal m-t-2 m-b-2" :class="{'fc-light-gray': loading1}" v-if="!loading">
        <i class="el-icon-loading" v-if="loading1"></i>
        <i class="el-icon-check" v-if="!loading1"></i>
        Setting up your account
      </h5>
      <h5 class="font-normal m-t-2 m-b-2" :class="{'fc-light-gray': loading2}" v-if="!loading">
        <i class="el-icon-loading" v-if="loading2"></i>
        <i class="el-icon-check" v-if="!loading2"></i>
        Customizing your content
      </h5>
      <h5 class="font-normal m-t-2 m-b-2 " :class="{'fc-light-gray': loading3}" v-if="!loading">
        <i class="el-icon-loading" v-if="loading3"></i>
        <i class="el-icon-check" v-if="!loading3"></i>
        Cleaning up
      </h5> -->
      <div v-if="loading">
        <loader/>
        <div class="t-c waiting-msg">
          Personalizing your content...
        </div>
      </div>
    </div>
    <div class="t-c action-buttons">
      <!-- <el-button type="primary" class="large" @click="next" :disabled="loading1 || loading2 || loading3">Start Using Luminary</el-button> -->
    </div>
  </div>
</template>

<script>
import * as log from 'loglevel';
import Loader from '../../components/Loader';

export default {
  name: 'OnboardingCompletePage',
  components: {
    Loader,
  },
  data() {
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      loading: true,
    };
  },
  beforeMount() {
    if (!this.$store.getters.creating_account.signup_completed || !this.$store.getters.creating_account.info_completed || !this.$store.getters.creating_account.categories_selected) this.$router.push('/listen');
    this.$store.commit('setCategoriesSelected', false);
    this.$store.commit('setInfoCompleted', false);
    this.$store.commit('setSignupCompleted', false);
  },
  mounted() {
    // this.loading1 = true
    // this.loading2 = true
    // this.loading3 = true
    // setTimeout(() => {
    //   this.loading1 = false
    // }, 2000)
    // setTimeout(() => {
    //   this.loading2 = false
    // }, 4000)
    // setTimeout(() => {
    //   this.loading3 = false
    // }, 6000)
    setTimeout(() => {
      this.loading = false;
      this.next();
    }, 5000);
    window.eventBus.$emit('onboarding-step-change', 5);
  },
  methods: {
    next() {
      // this.$router.push('/');
      const path = this.$store.getters.redirect_user;
      log.info(path);
      if (path) {
        this.$store.dispatch('setRedirectPath', null);
        this.$store.commit('setCategoriesSelected', false);
        this.$store.commit('setInfoCompleted', false);
        this.$store.commit('setSignupCompleted', false);
        this.$router.push(path);
      }
    },
  },
};
</script>

<style lang="scss">
.onboarding-complete-page {
  .content-area {
    max-width: 275px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
    h5 { display: flex; align-items: center; margin-bottom: 32px; }
    i {
      font-size: 32px;
      margin-right: 16px;
    }
    i.el-icon-check {
      border: 1px solid;
      border-radius: 5px;
    }
    .waiting-msg{
      margin-top: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/onboarding/Complete.vue